
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap-webflow.xml",
      function () {
        return require("private-next-pages/sitemap-webflow.xml.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap-webflow.xml"])
      });
    }
  